export const keyFeaturesData = [
  {
    id: 1,
    title: "User Registration & Authentication",
    listOne: "Secure login with multi-factor authentication",
    listTwo: "Integration with social media and email sign-up options",
  },
  {
    id: 2,
    title: "Loan Application & Eligibility Check",
    listOne: "Automated loan application process",
    listTwo: "Credit score assessment and eligibility verification",
  },
  {
    id: 3,
    title: "Loan Approval & Disbursement",
    listOne: "AI-driven risk assessment for quick approvals",
    listTwo: "Direct fund transfer to bank accounts or digital wallets",
  },
  {
    id: 4,
    title: " Loan Management & Repayment",
    listOne: "Loan tracking dashboard for users",
    listTwo:
      "Multiple repayment options (bank transfer, UPI, credit/debit cards, auto-debit)",
  },
  {
    id: 5,
    title: "Interest Rate & EMI Calculator",
    listOne: "Built-in loan calculator for users to check monthly EMI payments",
    listTwo: "Real-time interest rate updates",
  },
  {
    id: 6,
    title: "Customer Support & Chatbot Integration",
    listOne: "24/7 customer assistance via chatbot",
    listTwo: "Live support with loan advisors",
  },
];

export const technologiesData = [
  {
    id: 1,
    title: "Blockchain Technology",
    description: ` It ensures secure, transparent, and tamper-proof transactions.
                  Blockchain-powered lending app development helps to prevent
                  fraud, reduce paperwork, and streamline the lending process.`,
    icon: require("../../../image/lending/tech-img-one.webp"),
  },
  {
    id: 2,
    title: "Artificial Intelligence (AI)",
    description: ` AI helps in automating loan approvals, credit scoring, and risk assessment. AI-driven algorithms can analyze vast amounts of data and make real-time decisions about loan eligibility.`,
    icon: require("../../../image/lending/tech-img-two.webp"),
  },
  {
    id: 3,
    title: "Machine Learning (ML)",
    description: ` Machine learning algorithms play a vital role in enhancing the loan approval process. ML models can continuously learn from user behavior, improving the accuracy of credit scoring systems and identifying potential risks in lending transactions.`,
    icon: require("../../../image/lending/tech-img-three.webp"),
  },
  {
    id: 4,
    title: "Cloud Computing",
    description: `Cloud computing enables loan lending apps to be highly scalable and cost-efficient. By leveraging the cloud, developers can ensure seamless app performance, data storage, and easy management of loans on a global scale.`,
    icon: require("../../../image/lending/tech-img-four.webp"),
  },
  {
    id: 5,
    title: "Big Data Analytics",
    description: ` Big data analytics allows lenders to analyze customer behavior, assess creditworthiness, and predict repayment trends. By processing large datasets, lending apps can make more accurate and data-driven decisions, minimizing the risk of loan defaults.`,
    icon: require("../../../image/lending/tech-img-five.webp"),
  },
  {
    id: 6,
    title: "Biometric Authentication",
    description: ` Biometric authentication features such as fingerprint scanning and facial recognition can significantly enhance the security of a loan lending app. These technologies ensure that only authorized individuals can access the app, preventing unauthorized access to sensitive financial data.`,
    icon: require("../../../image/lending/tech-img-six.webp"),
  },
];
